<template>
	<selectize v-model="intVal" :key="keyPrefix + JSON.stringify(photoVariantOptions)" :settings="photoVariantSettings"></selectize>
</template>

<script>

export default {

	props: {
		value: [String, Number],
		none: {
			type: String,
			default: 'None',
		},
		keyPrefix: {
			type: String,
			default: '',
		},
		form: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			intVal: this.value,
		};
	},

	watch: {

		intVal(newValue) {
			this.$emit('input', newValue);
		},

	},

	computed: {

		photoVariantOptions() {
			let options = [
				{
					value: 0,
					text: this.none,
				},
			];

			this.form.variants.forEach(variant => {
				const groupNames = [];
				this.form.variant_groups.forEach(group => {
					groupNames.push(variant.groups[ group.id ] || 'Unnamed');
				});

				options.push({
					value: variant.id,
					text: groupNames.join(' > '),
				});
			});

			return options;
		},

		photoVariantSettings() {
			return {
				persist: true,
				options: this.photoVariantOptions,
				create: false,
			};
		},

	},

};

</script>
